import React, { Component } from "react";
import { getSingle } from "../../services/paidChequeService";

import { Table, Grid } from "semantic-ui-react";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Link } from "react-router-dom";
import TableTitle from "../common/tableTitle";
import Form from "../common/form";
import _ from "lodash";
import auth from "../../services/authService";

class PaidChequeDetail extends Form {
  state = {
    visa: {},
    visaId: "",
    open: false,
    paymentDate: new Date(),
    ledgerType: 1,
    data: {
      payment: "",
      description: ""
    },
    errors: {},
    pageSize: 500,
    currentPage: 1,
    keyFieldValue: "",
    sortColumn: { path: "sort_date", order: "asc" }
  };

  async getVisaDetail(visaId) {
    try {
      this.setState({ blocking: true });

      const { data: visa } = await getSingle(visaId);

      this.setState({ visa, blocking: false, visaId });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    const visaId = this.props.match.params.id;
    await this.getVisaDetail(visaId);

    this.setState({ blocking: false });
  }

  render() {
    const { visa } = this.state;

    return (
      <BlockUi tag="div" blocking={this.state.blocking}>

        <TableTitle title="Invoice detail" icon="tag" />

        <center>
          <div className="outer-container">
            <Grid columns={2} divided>
              <Grid.Row>
                <Grid.Column>
                  <Table definition>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell width={4}>Invoice Date</Table.Cell>
                        <Table.Cell>{visa.invoice_date}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={4}>Invoice#</Table.Cell>
                        <Table.Cell>{visa.invoice_number}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={4}>Client</Table.Cell>
                        <Table.Cell>{visa.client}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={4}>Total Work Done</Table.Cell>
                        <Table.Cell>{visa.total_work_done}</Table.Cell>
                      </Table.Row>

                      <Table.Row>
                        <Table.Cell width={4}>Retension Percentage</Table.Cell>
                        <Table.Cell>{visa.retention_percentage}%</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={4}>Retension Amount</Table.Cell>
                        <Table.Cell>{visa.retention_amount}</Table.Cell>
                      </Table.Row>


                    </Table.Body>
                  </Table>
                </Grid.Column>
                <Grid.Column>
                  <Table definition>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell width={4}>Total Amount</Table.Cell>
                        <Table.Cell>{visa.total_amount}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={4}>Client</Table.Cell>
                        <Table.Cell>{visa.client}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={4}>Total Work Done</Table.Cell>
                        <Table.Cell>{visa.total_work_done}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={4}>VAT Percentage</Table.Cell>
                        <Table.Cell>{visa.vat_percentage}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={4}>VAT Amount</Table.Cell>
                        <Table.Cell>{visa.vat_amount}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={4}>Grand Total</Table.Cell>
                        <Table.Cell>{visa.grand_total}</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                  <Link to="/invoices" className="ui secondary button">
                    Back
              </Link>
                </Grid.Column>
              </Grid.Row>



            </Grid>
          </div>
        </center>
      </BlockUi>
    );
  }
}

export default PaidChequeDetail;
